import { ArrowLongRightIcon } from '@heroicons/react/24/outline';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  illustration?: ReactNode;
}

export function EmptyState({ title, description, actionLabel, onAction, illustration }: EmptyStateProps): JSX.Element {
  return (
    <div className="glass-card flex flex-col items-center gap-4 px-6 py-12 text-center">
      <div className="h-16 w-16 rounded-full bg-gradient-to-br from-primary/20 to-accent/20" aria-hidden>
        {illustration}
      </div>
      <div>
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        <p className="mt-2 max-w-md text-sm text-muted-foreground">{description}</p>
      </div>
      {actionLabel && (
        <button
          type="button"
          onClick={onAction}
          className="focus-ring inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-lg shadow-primary/30 transition hover:bg-primary/90"
        >
          {actionLabel}
          <ArrowLongRightIcon className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
